module.exports = __webpack_public_path__ + "e99ae2a34061dd2487cb05526bb89e6d.png";